import { render, staticRenderFns } from "./CreateProjectDialog.vue?vue&type=template&id=d2892f22&scoped=true&"
import script from "./CreateProjectDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateProjectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CreateProjectDialog.vue?vue&type=style&index=0&id=d2892f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2892f22",
  null
  
)

export default component.exports